const initImageBlogArticle = () => {
    const blogArticle = document.querySelector(".content-article");
    if (blogArticle) {
        const imgRichTextBlogArticleArray = blogArticle.querySelectorAll("img");
        if (imgRichTextBlogArticleArray && imgRichTextBlogArticleArray.length > 0) {
            imgRichTextBlogArticleArray.forEach(imgRichTextBlogArticle => {
                imgRichTextBlogArticle.parentElement.classList.add("image-container");
            });
        }
    }
};
